// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"SQ","mainContent":"TQ","activeSidebar":"UQ"};